module.exports = __webpack_public_path__ + "img/CSS3_logo_and_wordmark.svg-min.fcf40d6a.png";